// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import "babel-polyfill";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "./assets/style/element-#E62B55/index.css";
import { ConfirmPlugin, AlertPlugin } from "./plugins/confirm/index";
import { ToastPlugin } from "./plugins/toast";
import VueLazyload from "vue-lazyload";
import loadingImg from "../public/images/common/default-placeholder.png";
import VueTextareaAutosize from "vue-textarea-autosize";
import HappyScroll from "vue-happy-scroll";
import "vue-happy-scroll/docs/happy-scroll.css";
import locale from "element-ui/lib/locale/lang/en";
import store from "./store/index";
import vuexI18n from "vuex-i18n";
import arLang from "./lang/ar";
import deDELang from "./lang/de-DE";
import enLang from "./lang/en";
import es419Lang from "./lang/es-419";
import frFRLang from "./lang/fr-FR";
import idLang from "./lang/id";
import itITLang from "./lang/it-IT";
import jaJPLang from "./lang/ja-JP";
import koKRLang from "./lang/ko-KR";
import msLang from "./lang/ms";
import ptBRLang from "./lang/pt-BR";
import ruRULang from "./lang/ru-RU";
import thLang from "./lang/th";
import zhTWLang from "./lang/zh-TW";
import zhLang from "./lang/zh";
// import Raven from 'raven-js'
// import RavenVue from 'raven-js/plugins/vue'
console.log("version 2019-7-18");
// Raven
//   .config('http://07ca9f3845fe4b4c8fedddf55d2811d9@74.207.250.143/2')
//   .addPlugin(RavenVue, Vue)
//   .install()
Vue.prototype.$bus = Vue.prototype.$bus || new Vue(); // 注册一个全局的总线组件
Vue.config.productionTip = false;
Vue.use(ElementUI, { locale });
Vue.use(vuexI18n.plugin, store);
Vue.use(VueTextareaAutosize);
Vue.use(ConfirmPlugin);
Vue.use(AlertPlugin);
Vue.use(ToastPlugin);
Vue.use(HappyScroll);
Vue.i18n.add("ar", arLang); // 阿拉伯语言包
Vue.i18n.add("de-DE", deDELang); // 德国语言包
Vue.i18n.add("en", enLang); // 英文语言
Vue.i18n.add("es-ES", es419Lang); // 西班牙语
Vue.i18n.add("fr-FR", frFRLang); // 法国
Vue.i18n.add("in-ID", idLang); // 印尼
Vue.i18n.add("id", idLang); // 印尼
Vue.i18n.add("it-IT", itITLang); // 意大利
Vue.i18n.add("ja-JP", jaJPLang); // 日本
Vue.i18n.add("ko-KR", koKRLang); // 韩国
Vue.i18n.add("ms", msLang); // 马来
Vue.i18n.add("pt-BR", ptBRLang); // 葡萄牙 -巴西
Vue.i18n.add("ru-RU", ruRULang); // 俄国
Vue.i18n.add("th-TH", thLang); // 泰国
Vue.i18n.add("zh-CN", zhLang); // 简体中文
Vue.i18n.add("zh-TW", zhTWLang); // 中文繁体(中华人民共和国)

// 图片懒加载
// or with options
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: loadingImg,
  loading: loadingImg,
  attempt: 1,
});
/* eslint-disable no-new */
const app = new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
});
export default app;
